/**
 * Add your components here.
 * @module components
 * @example
 * import Footer from './Footer/Footer';
 *
 * export {
 *   Footer,
 * };
 */
import loadable from '@loadable/component';

const AddToCalendar = loadable(() =>
  import('@package/components/Widgets/AddToCalendar'),
);

export { AddToCalendar };
